module.exports = __webpack_public_path__ + "52943248074a824a42f0492e4aa53195.pdf";